import { DataRow } from '../../../components'
import {
  MerchantPaneAmountContainer,
  MerchantPaneInfoContainer,
  MerchantPaneLogoContainer,
  MerchantPaneWrapper
} from './MerchantPane.styled'

import { formatMoney, tr } from 'mmfintech-commons'

export const MerchantPane = ({ session }) => {
  if (session) {
    const { amount, currency, foreignTransactionId, merchantName } = session || {}

    return (
      <MerchantPaneWrapper>
        <MerchantPaneAmountContainer>
          <MerchantPaneLogoContainer>
            <div>
              <div className='label'>{tr('CHECKOUT.PAYMENT.AMOUNT', 'Amount')}</div>
              <div className='value'>{formatMoney(amount, currency)}</div>
            </div>
          </MerchantPaneLogoContainer>
        </MerchantPaneAmountContainer>
        <MerchantPaneInfoContainer>
          <DataRow label={tr('CHECKOUT.PAYMENT.PAY_TO', 'Pay to')} value={merchantName} />
          <DataRow label={tr('CHECKOUT.PAYMENT.TRANSACTION_ID', 'Transaction ID')} value={foreignTransactionId} />
        </MerchantPaneInfoContainer>
      </MerchantPaneWrapper>
    )
  }

  return null
}
